var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgInputField = function SvgInputField(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 19H11.1C10.6226 19 10.1648 18.8156 9.82721 18.4874C9.48964 18.1592 9.3 17.7141 9.3 17.25M9.3 17.25C9.3 17.7141 9.11036 18.1592 8.77279 18.4874C8.43523 18.8156 7.97739 19 7.5 19H6.6M9.3 17.25V6.75M12.9 8.5H19.2C19.6774 8.5 20.1352 8.68437 20.4728 9.01256C20.8104 9.34075 21 9.78587 21 10.25V13.75C21 14.2141 20.8104 14.6592 20.4728 14.9874C20.1352 15.3156 19.6774 15.5 19.2 15.5H12.9M5.7 15.5H4.8C4.32261 15.5 3.86477 15.3156 3.52721 14.9874C3.18964 14.6592 3 14.2141 3 13.75V10.25C3 9.78587 3.18964 9.34075 3.52721 9.01256C3.86477 8.68437 4.32261 8.5 4.8 8.5H5.7M6.6 5H7.5C7.97739 5 8.43523 5.18437 8.77279 5.51256C9.11036 5.84075 9.3 6.28587 9.3 6.75M9.3 6.75C9.3 6.28587 9.48964 5.84075 9.82721 5.51256C10.1648 5.18437 10.6226 5 11.1 5H12",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgInputField);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "input-field.aafd7d8021abebfae4cdfd0f8dcc40ac.svg";